export default "__VITE_ASSET__C2x0jdTv__"